import { render, staticRenderFns } from "./secondLayout.vue?vue&type=template&id=3188b96c&scoped=true"
import script from "./secondLayout.vue?vue&type=script&lang=js"
export * from "./secondLayout.vue?vue&type=script&lang=js"
import style0 from "./secondLayout.vue?vue&type=style&index=0&id=3188b96c&prod&lang=less&scoped=true&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188b96c",
  null
  
)

export default component.exports